import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DelayStepForLead as DelayStepForLeadMutation,
    DelayStepForLeadVariables,
    StepDelayInput,
} from 'nutshell-graphql-types';

import DELAY_STEP_FOR_LEAD from '../mutations/delay-step-for-lead.graphql';

export const useDelayStepForLead = (): {
    delayStepForLead: (arg1: StepDelayInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [delayStepForLead, {loading, error}] = useMutation<
        DelayStepForLeadMutation,
        DelayStepForLeadVariables
    >(DELAY_STEP_FOR_LEAD);

    return {
        delayStepForLead: (input: StepDelayInput) => delayStepForLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
